import { apiClient, Auth } from '@/shared/api'

import { TRoomsSearchParams, TRoomsResponse } from './schema'

export const getRooms = async (params: TRoomsSearchParams) => {
  const { data } = await apiClient.get<TRoomsResponse>({
    endpoint: `/rooms`,
    queryParams: params,
    auth: Auth.OPTIONAL,
  })

  return data
}
